<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-team-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <h6 class="title"></h6>

                <div class="dialog-body">
                    <div class="table-head"></div>
                    <table>
                        <tbody>
                            <tr v-for="(item,index) in $store.state.team" :key="item.uid">
                                <th style="width: 226px;" class="team-member">
                                    <div class="wrapper">
                                        <div class="avatar"><img :src="require('@/assets/images/avatar/'+ (index + 1) +'.jpg')" :alt="item.uid"></div>
                                        <p class="player-name" :title="item.name">{{ item.name }}</p>
                                    </div>
                                </th>
                                <th style="width: 111px;">{{ item.level }}</th>
                                <th style="width: 141px;">{{ item.score }}</th>
                                <th style="background-image : none;">{{ item.corpName }}</th>
                            </tr>
                            <tr v-for="n in (5 - $store.state.team.length)" :key="n">
                                <th style="width: 226px;" class="team-member">
                                    <div class="wrapper">
                                        <div class="u-btn add" @click="call_team_invite()"></div>
                                        <p class="player-name">暂无</p>
                                    </div>
                                </th>
                                <th style="width: 111px;">-</th>
                                <th style="width: 141px;">-</th>
                                <th style="background-image : none;">-</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
  
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            shareTxt : '组队成功后可获得周年庆集结大礼包一份快去邀请好友加入小队吧！',
            gid : '',
            max : 5,
        }
    },
    created (){
        if(!this.$store.state.login){
            return this.$mslogin.open();
        }
        if(!this.$store.state.userinfo){
            this.$bind_modal();
            return this.$toast('请先选择大区');
        }

        //this.render();
    },  
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        call_team_invite (){
            if(!this.$store.state.team.length)return this.$warn_modal();
            if(this.$store.state.team.length == this.max)return this.$msg_modal({text : '你的小队人数已满，快去收集燃梦火炬兑换奖励吧！'});

            this.$share_modal();
        },             
    },
}
</script>

<style scoped>
.m-team-modal {
    width: 740px;
    height: 601px;
    font-size: 22px;
    color: #a1837d;
    background-image: url(~@/assets/images/utils/bg-modal-team.png);
}

.m-team-modal h6 {
    /* height: 14px; */
    width: 450px;
    height: 30px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/utils/title-team.png); 
}

.table-head{
    width: 681px;
    height: 50px;
    margin: 0 auto;
    background-image: url(~@/assets/images/utils/table-head.png); 
}

table{
    width: 708px;
    margin: 0 auto;
}

tr{
    border-bottom: 1px solid #f2d3bc;
}

tr:nth-last-child(1){
    border: none;
}

th{
    height: 95px;
    background-image: url(~@/assets/images/utils/table-right.png);
    background-position: right center;
    background-repeat: no-repeat;
}

.team-member{
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-left: 17px;   
}

.team-member p{
    display: inline-block;
    width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
}

.avatar,
.u-btn.add {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
    margin-right: 10px;
    background-image: url(~@/assets/images/utils/btn-add.png);
    vertical-align: middle;   
}

.avatar img{
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 58px;
    height: 58px;
    border-radius: 10px;
    transform: translate(-50%,-50%);
}

.player-name{
    display: inline-block;
    vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/TeamInfo/teaminfo.vue